import React, { FC } from "react";

interface HelpColorProps {}

const HelpColor: FC<HelpColorProps> = () => {
  return (
    <div className="absolute top-0 z-[1000000] bg-white flex gap-6 px-2 py-1">
      {Object.keys(determiningAreasColor).map((key: string, index: number) => {
        //show the polygon colors
        return (
          <div key={index} className="flex items-center gap-2">
            <span className="">{determiningAreasColor[key].title}</span>
            <div
              style={{ backgroundColor: determiningAreasColor[key].color }}
              className={` flex w-2 h-2`}
            />
          </div>
        );
      })}
    </div>
  );
};

export default HelpColor;

interface ConvetColorinterface {
  title: string;
  color: string;
}
export const determiningAreasColor: Record<number, ConvetColorinterface> = {
  2: { title: " هاب", color: "red" },
  3: { title: " جمع آوری", color: "#dd2296" },
  4: { title: " توزیع", color: "#6D67E4" },
  5: { title: " جمع آوری /توزیع", color: "green" },
  6: { title: "هاب غیر فعال", color: "#5C636E" },
};
